(function () {
  angular
    .module('kareo.ui.shared.directives.validation.k-valid-zip', [
      'kareo.ui.shared.modules.regex.zip-code-regex'
    ])
    .directive('kValidZip', kValidZip);

  kValidZip.$inject = ['ZIP_CODE_REGEX'];

  function kValidZip(ZIP_CODE_REGEX) {
    return {
      link,
      require: 'ngModel'
    };

    function link(scope, elem, attr, ngModel) {
      elem.attr('maxlength', 10);
      ngModel.$validators.zip = function validateZip(modelValue, viewValue) {
        return ngModel.$isEmpty(viewValue) || ZIP_CODE_REGEX.test(viewValue);
      };
    }
  }
})();
